import { render, staticRenderFns } from "./APPVersion.vue?vue&type=template&id=033977f5&"
import script from "./APPVersion.vue?vue&type=script&lang=js&"
export * from "./APPVersion.vue?vue&type=script&lang=js&"
import style0 from "./APPVersion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports